import Api from '@/services/Api'

class GroupApi {
    static getPlan(plan_id) {
        return new Promise(async(resolve, reject) => {
            try {
                const res = await Api().get('plans/' + plan_id)
                const data = res.data
                resolve(data)
            } catch(err) {
                reject(err)
            }
        })
    }

    static getPlans() {
        return new Promise(async(resolve, reject) => {
            try {
                const res = await Api().get('plans')
                const data = res.data
                resolve(data)
            } catch(err) {
                reject(err)
            }
        })
    }
}

export default GroupApi


// WEBPACK FOOTER //
// ./src/services/PlanApi.js